export class RmInvoiceReq{
    grnId:number
    indentId:number
    company?:string
    batchNumber?: any
    year?:any

    constructor(grnId:number,indentId:number,company?:string,batchNumber?: any,year?:any
    ){
        this.grnId = grnId
        this.indentId = indentId
        this.batchNumber = batchNumber
        this.company = company
        this.year=year
    }
}